/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getSettings } from '../../lib/setting'; // Kept for prefix fallback only
import { api } from '../../config/api';

const useNextInquireNumber = () => {
    const [nextInquireNumber, setNextInquireNumber] = useState('');

    // Fetch settings data
    const { data: settingsData, isLoading: settingsLoading } = useQuery(
        ['settings'],
        getSettings,
        {
            refetchOnWindowFocus: false,
        }
    );

    // Fetch next inquire-number preview from backend (Admin SDK)
    const { data: previewData, isError } = useQuery(
        ["inquire-number-preview"],
        async () => {
            const res = await api.get('/firestore/inquire-number/preview');
            return res.data; // { prefix, next, inquireNumber }
        },
        {
            refetchOnWindowFocus: false,
        }
    );

    useEffect(() => {
        if (!settingsLoading && !isError && previewData) {
            if (previewData?.inquireNumber) {
                setNextInquireNumber(previewData.inquireNumber);
            } else {
                // Fallback: build from settings when preview not available
                setNextInquireNumber(`${settingsData?.inquireNumber_Prefix || 'IN'}-001`);
            }
        }
    }, [settingsLoading, isError, previewData]);

    return { nextInquireNumber };
};

export default useNextInquireNumber;
